import API from '../../../services/apiService.js'

var api= new API();


export default {
    /*
      getMenuItems({commit}){

        var data= [{title:'Главная', name:"Main", icon:"grade"},{title:'Пользователи', name:"Users", icon:"account_circle"},
          {title:'Заявки', name:"Requests", icon:"assignment"},
          {title:'Работа с клиентами', name:"ClientSupport", icon:"question_answer"},
          {title:'Управление бонусами', name:"BonusManagement", icon:"stars"},
          {title:'Регистрация клиентов', name:"ClientRegister", icon:"group_add"},
          {title:'Управление акциями', name:"Stocks", icon:"card_giftcard"},
          {title:'Справочники',
            name:"directories",
            icon:"dashboard",
            childrens:[{title:'Организации', name:"Organizations", icon:"dashboard"},
              {title:'Адреса партнеров', name:"OrgBranches", icon:"dashboard"},
              {title:'Список бонусов', name:"Bonuses", icon:"dashboard"},
              {title:'Список штрафов', name:"Fines", icon:"dashboard"},
              {title:'Список моделей авто', name:"Cars", icon:"dashboard"},
              {title:'Список городов', name:"Cities", icon:"dashboard"},
              ]}];

        return new Promise((resolve) => {
          commit('getMenuItems', data);
          resolve();
        });
      },
    */

    async getMenuItems({commit}) {
        let data = null
        try {
            data = await api.Get("UserService/WebMenu");
            commit('setMenu', data)
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },
    //изменить аватар пользователя
    async changeWebUSerLogo({commit}, model) {
        try {
            await api.Post("UserService/WebUser/Logo", model);
            commit('changeWebUSerLogo', model);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    async loadWebUserData({commit}, identityId){
        let data=null
        try{
            var getparams = '?Id=' + identityId;
            data= await api.Get("UserService/WebUser/GetById" + getparams)
            commit("userData/setWebUserInfo", data)
        }
        catch (e) {
            console.log(e);
            throw new Error(e);
        }
    }


}
